<script setup>
defineProps({
  content: { type: Object, required: true },
  variant: { type: String, default: 'footer-01' },
})
</script>

<template>
  <footer class="b2-footer" :class="`variant-${variant}`">
    <div class="b2-footer-inner">
      <div class="b2-footer-col b2-footer-brand">
        <div class="b2-footer-logo">{{ content.footer_logo.value }}</div>
        <p>{{ content.tagline.value }}</p>
      </div>
    </div>
    <div class="b2-footer-bottom">
      <p>{{ content.footer_disclaimer.value }}</p>
    </div>
  </footer>
</template>

<style scoped>
.b2-footer { background: #0f1f13; color: rgba(255,255,255,.7); padding: 70px 40px 30px; }
.b2-footer-inner { max-width: 1200px; margin: 0 auto 50px; }
.b2-footer-logo { font-family: 'Playfair Display', serif; font-size: 22px; color: white; margin-bottom: 14px; }
.b2-footer-col p { font-size: 14px; line-height: 1.7; max-width: 480px; }
.b2-footer-bottom { max-width: 1200px; margin: 0 auto; border-top: 1px solid rgba(255,255,255,.08); padding-top: 24px; font-size: 13px; color: rgba(255,255,255,.3); text-align: center; }
.variant-footer-02 { background: #f5f9f4; color: #526056; border-top: 1px solid #dce7da; }
.variant-footer-02 .b2-footer-logo { color: #1a3320; }
.variant-footer-02 .b2-footer-bottom { border-color: #dce7da; color: #879189; }
.variant-footer-03 { background: #4a8c3f; text-align: center; padding-top: 54px; }
.variant-footer-03 .b2-footer-col p { margin: 0 auto; }
.variant-footer-03 .b2-footer-logo { font-size: 30px; }
.variant-footer-03 .b2-footer-bottom { color: rgba(255,255,255,.58); }
</style>
